import { createSelectorCreator, defaultMemoize } from 'reselect';
import { isEqual } from 'lodash';

/**
 * Any selectors using this will use 'isEqual' to determine equality.
 * This means that if I have:
 * a = { hello: 'world'};
 * b = { hello: 'world'};
 * normalSelector = createSelector((state) => state.hello), (hello) => expensiveOperation(hello));
 * deepEqualSelector = createDeepEqualSelector((state) => state.hello), (hello) => expensiveOperation(hello));
 *
 * Using normalSelector on `a` or `b` will cause it to rerun the selector
 * but using deepEqualSelector will only run this once for `a` or `b`, as the object contents are identical
 */
const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export default createDeepEqualSelector;
export { createDeepEqualSelector };
